import {
  SET_AUTHENTICATED,
  SET_IS_IMPERSONATING,
  SET_REGISTRATION_DATA,
  SET_2F_AUTHENTICATION
} from './mutation-types'

export default {
  [SET_AUTHENTICATED]: (state, { authenticated }) => {
    state.authenticated = authenticated
  },
  [SET_IS_IMPERSONATING]: (state, { isImpersonating }) => {
    state.isImpersonating = isImpersonating
  },
  [SET_REGISTRATION_DATA]: (state, { step, email }) => {
    state.registrationStep = step
    state.userEmail = email
  },
  [SET_2F_AUTHENTICATION]: (state, { email }) => {
    state.userEmail = email
  }
}
